/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Layout Controls

/**
 * NGC Layout Module
 */
@NgModule({
    exports: [

    ]
})
export class NgcLayoutModule {
}